import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom'

import Navigator from '../Navigator';
const Strings = require('../../../app/shared/Strings');
const TemplateStore = require('../stores/template_store_reflux');
const VoiceStore = require('../stores/VoiceStore');
const ChatbotSystem = require('../util/ChatbotSystem');
import TopNav from './DashboardNew/Menu/TopNav';
import LoadingMainContent from './loading/LoadingMainContent';
import HelpDropdown from './nav/HelpDropdown';
import ReportTestResultModal from './modal/ReportTestResultModal';
import IFrame from './IFrame';
const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
import WithActivityData from './DataHOCs/WithActivityData';
import WithChannelData from './DataHOCs/WithChannelData';
import WithProjectData from './DataHOCs/WithProjectData';
import WithDocumentVisible from './DataHOCs/WithDocumentVisible';
import WithActivityEditAccessData from './DataHOCs/WithActivityEditAccessData';

const propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
    }).isRequired,
    activityStoreState: PropTypes.shape({ activity: PropTypes.object }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.object.isRequired }).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.object.isRequired }).isRequired,
    activityEditAccessInfo: PropTypes.shape({ id: PropTypes.string.isRequired, access_key: PropTypes.string.isRequired, permissions: PropTypes.object.isRequired }).isRequired,
};

const defaultProps = {};

class PreviewActivityView extends React.Component {
    constructor(props) {
        super(props);

        let templateStoreState = { initialized: false };
        if (props.activityStoreState.initialized && props.activityStoreState.activity) {
            const moduleID = props.activityStoreState.activity.module_id;
            templateStoreState = TemplateStore.getStateTemplate(moduleID);
        }
        else {
            console.warn('props.activityStoreState.activity:', props.activityStoreState.activity);
        }

        let canReportTestResults = false;
        if (GlobalConfig.CanReportTestResults &&
            this.props.activityEditAccessInfo &&
            this.props.activityEditAccessInfo.admin) { // this.props.activityEditAccessInfo.permissions.xxx
            canReportTestResults = true;
        }

        this.state = {
            templateStoreState: templateStoreState,
            hasError: false,
            message: '',
            clientFeatures: {
                user_data: false,
            },
            canReportTestResults,
        };

        this.iframe = React.createRef();
        this.onClose = this.onClose.bind(this);
        this.onReportTestResult = this.onReportTestResult.bind(this);
        this.onClientFeatures = this.onClientFeatures.bind(this);
        this.sendUserData = this.sendUserData.bind(this);

        this.unsubscribes = [
            TemplateStore.listen(this.onTemplateStoreChange.bind(this))
        ];
        
        const userData = {...props.activityEditAccessInfo, 
            activityId: props.activityId ? Number(props.activityId) : null,
            channelId: props.channelId ? Number(props.channelId) : null,
        }
        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.ACTIVITY_PREVIEW,{userData});
        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.ACTIVITY_PREVIEW});
    }

    handleMessage=(e)=>{
        const msg = e.originalEvent.data;
        const origin = e.originalEvent.origin;

        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }

        const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;
        
        if (this.chatbotSystem && msg.type && msg.type.includes("chatbot")) {
            let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
            // fall thru to other handlers
        }
        
        if (this.voiceSystem) {
            let handled = this.voiceSystem.handleMessage(msg,targetWindow);
            if (handled) {
                return;
            }
        }
        switch (msg.type) {
            case 'features': {// client telling forge what it can do
                this.onClientFeatures(msg.features);
                break;
            }
            case "request-user-data": {
                this.sendUserData();
                break;
            }
            case 'auto-close':
                this.onClose();
                break;
        }
    }


    componentDidMount() {
        if (!PermissionsUtil.canPreviewActivity(this.props.channelStoreState.channel.user_permissions, this.props.projectStoreState.project.user_permissions)) {
            this.onClose();
            return;
        }

        $(window).off('message', this.handleMessage).on('message', this.handleMessage);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        $(window).off('message', this.handleMessage);
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }
    }

    onTemplateStoreChange(state) {
        if (state.initialized) {
            const moduleID = this.props.activityStoreState.activity.module_id;
            this.setState({ templateStoreState: TemplateStore.getStateTemplate(moduleID) });
        }
        else {
            this.setState({ templateStoreState: { initialized: false } });
        }
    }

    onClose() {
        Navigator.goToActivityView(this.props.history, this.props.channelId, this.props.projectId, this.props.activityId);
    }
    
    onReportTestResult() {
        this.setState({showTestReportDialog:true});
    }

    onClientFeatures(features) {
        const self = this;
        this.setState({ clientFeatures: features }, () => {
            self.sendUserData();
        });
    }

    sendUserData() {
        if (this.state.clientFeatures.user_data) {
            const iframe = this.iframe.current;
            if (!!iframe) {
                iframe.contentWindow.postMessage({ type: 'user-data', user_data: this.props.activityEditAccessInfo }, '*');
            }
        }
    }

    render() {
        let mainContent;
        let testElement = null;
        if (this.state.hasError) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <h2>Error: {this.state.message}</h2>
                </div>
            );
        }
        else if (!this.state.templateStoreState.initialized || !this.props.activityStoreState.activity) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <LoadingMainContent/>
                </div>
            );
        }
        else {
            const _activity = this.props.activityStoreState.activity;
            const _template = this.state.templateStoreState.template;

            let _version_suffix = '';
            if (this.props.match.params.activityVersion) {
                _version_suffix = `/${this.props.match.params.activityVersion}`;
            }
            const urlParams = new URLSearchParams(window.location.search);
            const post_publish = urlParams.get("post_publish"); // redmine #6884
            
            let iframeStyle = {};
            if (this.state.canReportTestResults) {
                if (this.state.showTestReportDialog) {
                    testElement = (
                        <ReportTestResultModal 
                            activity_id={_activity.id} version={this.props.match.params.activityVersion}
                            client_version_hash={this.state.clientFeatures.client_version_hash}
                            closeHandler={()=>{this.setState({showTestReportDialog: false})}} />
                    );
                    iframeStyle={pointerEvents: 'none'}; // prevent clicks on the modal dialog over the iframe from going to the iframe
                }
                else {
                    testElement = <Button variant="light" className="editorButton" style={{marginLeft:'1rem'}} onClick={this.onReportTestResult}>{Strings['en'].common.REPORT}</Button>
                }
            }
            const title = _activity.meta_data.display_name || _activity.meta_data.title;
            const launch_mode = post_publish ? 'post_publish' : 'preview'; // redmine #7359
            mainContent = <IFrame ref={this.iframe} style={iframeStyle} title={title} url={`${_template.template_url}/${launch_mode}/web/${_activity.activity_id + _version_suffix}`}/>;
        }

        return (
            <div className="preview-activity">
                <TopNav onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(this, this.props.history, this.props.channelId)}>
                    <HelpDropdown/>
                    <Button variant="light" className="editorButton" onClick={this.onClose}>{Strings['en'].common.CLOSE}</Button>
                    {testElement}
                </TopNav>
                {mainContent}
            </div>
        );
    }
}

PreviewActivityView.propTypes = propTypes;
PreviewActivityView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithActivityData(WithChannelData(WithProjectData(WithDocumentVisible(WithActivityEditAccessData(PreviewActivityView))))));

// WithActivityData is expected the activityId prop. "Rename" props.params.activityID to props.activityId here. do the same with projectId & channelId
function WrappedComponentWithUpdatedPropNames(props) {
    return <WrappedComponent {...props} activityId={props.match.params.activityId} projectId={props.match.params.projectID} channelId={props.match.params.channel}/>;
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({ channel: PropTypes.string.isRequired, projectID: PropTypes.string.isRequired, activityId: PropTypes.string.isRequired, activityVersion: PropTypes.string }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;